"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
String.equalCaseInsensitive = (leftStr, rightStr) => {
    if (_.isEmpty(leftStr) && _.isEmpty(rightStr)) {
        return true;
    }
    if (leftStr !== undefined && rightStr !== undefined) {
        return _.toLower(leftStr) === _.toLower(rightStr);
    }
    return false;
};
String.equalCI = (leftStr, rightStr) => {
    return String.equalCaseInsensitive(leftStr, rightStr);
};
String.isUndefinedOrEmpty = (str) => {
    return str ? str.trim() === '' : true;
};
String.padZero = (str, length) => {
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
};
String.toBoolean = (str) => {
    if (_.isEmpty(str)) {
        return false;
    }
    return ['yes', 'y', 'true', 'on', '1'].includes(_.toLower(str));
};
String.toCamelCase = (str) => {
    return str
        .replace(/\s(.)/g, function ($1) {
        return $1.toUpperCase();
    })
        .replace(/\s/g, '')
        .replace(/^(.)/, function ($1) {
        return $1.toLowerCase();
    });
};
//# sourceMappingURL=string-extensions.js.map